const state = () => ({
  is_vip: 1,
  preview_jinbi_discount: 10,
  jinbi_discount: "",
  bindPhone: "",
  money: "",
  kfurl: "",
  avatar_text: "",
  username: "",
  gender: "",
  id: "",
  plain_password: "",
  vip_time: "",
  usertoken: "",
  community_url: "",
  msg: "",
  unread: 0,
  bobi: '',
  t_video: '',//短视频免费次数
  d_video: '',//长视频免费次数
  diamond: '',
  ai_cast_num: 0,
  parentid: 0
});

const getters = {
  is_vip: (state) => state.is_vip,
  preview_jinbi_discount: (state) => state.preview_jinbi_discount,
  jinbi_discount: (state) => state.jinbi_discount,
  bindPhone: (state) => state.bindPhone,
  money: (state) => state.money,
  kfurl: (state) => state.kfurl,
  avatar_text: (state) => state.avatar_text,
  username: (state) => state.username,
  gender: (state) => state.gender,
  id: (state) => state.id,
  plain_password: (state) => state.plain_password,
  vip_time: (state) => state.vip_time,
  usertoken: (state) => state.usertoken,
  community_url: (state) => state.community_url,
  msg: (state) => state.msg,
  unread: (state) => state.unread,
  bobi: (state) => state.bobi,
  t_video: (state) => state.t_video,
  d_video: (state) => state.d_video,
  diamond: (state) => state.diamond,
  ai_cast_num: (state) => state.ai_cast_num,
  parentid: (state) => state.parentid,
};

const mutations = {
  setIs_vip(state, is_vip) {
    state.is_vip = is_vip;
  },
  setPreview_jinbi_discount(state, preview_jinbi_discount) {
    state.preview_jinbi_discount = preview_jinbi_discount;
  },
  setJinbi_discount(state, jinbi_discount) {
    state.jinbi_discount = jinbi_discount;
  },
  setBindPhone(state, bindPhone) {
    state.bindPhone = bindPhone;
  },
  setMoney(state, money) {
    state.money = money;
  },
  setKfurl(state, kfurl) {
    state.kfurl = kfurl;
  },
  setAvatar_text(state, avatar_text) {
    state.avatar_text = avatar_text;
  },
  setUsername(state, username) {
    state.username = username;
  },
  setGender(state, gender) {
    state.gender = gender;
  },
  setId(state, id) {
    state.id = id;
  },
  setPlain_password(state, plain_password) {
    state.plain_password = plain_password;
  },
  setVip_time(state, vip_time) {
    state.vip_time = vip_time;
  },
  setUsertoken(state, usertoken) {
    state.usertoken = usertoken;
  },
  setCommunity_url(state, community_url) {
    state.community_url = community_url;
  },
  setMsg(state, msg) {
    state.msg = msg;
  },
  setUnread(state, unread) {
    state.unread = unread;
  },
  setBobi(state, bobi) {
    state.bobi = bobi;
  },
  setTvideo(state, t_video) {
    state.t_video = t_video;
  },
  setDvideo(state, d_video) {
    state.d_video = d_video;
  },
  setDiamond(state, diamond) {
    state.diamond = diamond;
  },
  setAinum(state, ai_cast_num) {
    state.ai_cast_num = ai_cast_num;
  },
  setParentid(state, parentid) {
    state.parentid = parentid;
  },
};

const actions = {};

export default {
  state,
  getters,
  mutations,
  actions,
};
